import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { MarketplaceAuthService } from './marketplace-auth.service';
import { AuthModalService } from './auth-modal.service';

/**
 * Interceptor de la API del marketplace: adjunta el Bearer token, y ante un 401
 * intenta refrescar una vez; si falla, cierra sesión y abre el modal de login
 * (sin sacar al usuario de la página en la que está).
 * Solo toca requests que van a /marketplace/ (no afecta las llamadas a C#). Ver SPEC-016.
 */
export const marketplaceAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/marketplace/')) return next(req);

  const auth = inject(MarketplaceAuthService);
  const modal = inject(AuthModalService);
  const isAuthCall = /\/auth\/(login|register|refresh)$/.test(req.url);

  const token = auth.accessToken;
  const authed = token && !isAuthCall ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authed).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status !== 401 || isAuthCall) return throwError(() => err);

      if (auth.refreshToken) {
        return auth.refresh().pipe(
          switchMap(() =>
            next(req.clone({ setHeaders: { Authorization: `Bearer ${auth.accessToken}` } })),
          ),
          catchError(() => {
            auth.logout();
            modal.open('login');
            return throwError(() => err);
          }),
        );
      }
      auth.logout();
      modal.open('login');
      return throwError(() => err);
    }),
  );
};
